import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuilderService {



  url = environment.serverAPI9 + "/api/builder";

  constructor(private http: HttpClient) { }

  AddEditBuilder(builder: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, builder)
  }

  getBuilderId(builderId: number): Observable<Object> {
    return this.http.get(`${this.url}/${builderId}`);
  }

  getallBuilder(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByBuilderId(builderId: any): Observable<Object> {
		return this.http.delete(`${this.url}/${builderId}`);
	} 

  BuilderSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  downloadBuilderTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }

  downloadBuilderReport(Page: number, size: number, sort,selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, { 
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
  getAllSpecification(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  sendEmail(emailInfo: any): Observable<any> {
    return this.http.post<Response[]>(`${this.url}/email/send` , emailInfo);
  }

  BuilderSearchLocation(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.post(`${this.url}/filter/location?page=${Page}&size=${size}&sort=${sort}`,query);
  }


}
